<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useMapStore } from '@/stores/mapStore.ts';
import PlayerName from '@/components/Objects/PlayerName.vue';

const mapStore = useMapStore();

// Function to update mouse position in the store
function updateMousePosition(event: MouseEvent) {
  mapStore.playerNameTooltipXPos = event.clientX;
  mapStore.playerNameTooltipYPos = event.clientY;
}

onMounted(() => {
  window.addEventListener('mousemove', updateMousePosition);
});

onUnmounted(() => {
  window.removeEventListener('mousemove', updateMousePosition);
});
</script>

<template>
  <div
    v-show="mapStore.playerNameTooltipVisible"
    :style="{
      left: mapStore.playerNameTooltipXPos + 'px',
      top: mapStore.playerNameTooltipYPos - tooltipOffset + 'px',
    }"
    class="tooltip bg-gray-900 z-20 px-1 rounded"
  >
    <span v-if="mapStore.playerNameTooltipOwnerId === 0 && mapStore.playerNameTooltipName">{{ mapStore.playerNameTooltipName }}</span>
    <span v-else-if="mapStore.playerNameTooltipCompatibility"
      :class="{
        'text-green-500': mapStore.playerNameTooltipCompatibility === 'A',
        'text-cyan-500': mapStore.playerNameTooltipCompatibility === 'B',
        'text-subtext': mapStore.playerNameTooltipCompatibility === 'C',
        'text-amber-400': mapStore.playerNameTooltipCompatibility === 'D',
        'text-red-500': mapStore.playerNameTooltipCompatibility === 'E',
        'text-blue-400': mapStore.playerNameTooltipCompatibility === 'F',
      }">{{
        mapStore.playerNameTooltipCompatibility === 'A' ? 'Paradise' :
        mapStore.playerNameTooltipCompatibility === 'B' ? 'Lush' :
        mapStore.playerNameTooltipCompatibility === 'C' ? 'Habitable' :
        mapStore.playerNameTooltipCompatibility === 'D' ? 'Incompatible' :
        mapStore.playerNameTooltipCompatibility === 'E' ? 'Toxic' :
        mapStore.playerNameTooltipCompatibility === 'F' ? 'Frozen' :
        mapStore.playerNameTooltipCompatibility
      }}</span>
    <template v-else>
      <PlayerName :player-id="Number(mapStore.playerNameTooltipOwnerId)" /> <span v-if="mapStore.playerNameTooltipShipCount>0">: {{ mapStore.playerNameTooltipShipCount }}</span>
    </template>
  </div>
</template>

<script lang="ts">
const tooltipOffset = 65; // Adjust this value based on your tooltip's height
</script>

<style scoped lang="scss">
.tooltip {
  position: absolute;
  /* Add any additional styling you need */
}
</style>
